"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _localization = require("@lt/localization");

var _PriceLink = _interopRequireDefault(require("../PriceLink"));

var Star = function Star(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#D0021B",
    fillRule: "evenodd",
    d: "M8 13.267L3.056 16 4 10.211l-4-4.1 5.528-.844L8 0l2.472 5.267L16 6.11l-4 4.1.944 5.789L8 13.267z",
    clipRule: "evenodd"
  }));
};

Star.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
};
var LONG_TEXT_TRESHOLD = 28;

var RecommendedCountries = function RecommendedCountries(props) {
  var isMobile = props.isMobile,
      className = props.className,
      recommendations = props.recommendations;

  var _useTranslation = (0, _localization.useTranslation)(),
      t = _useTranslation.t;

  if (!Array.isArray(recommendations) || !recommendations.length) return null;
  var pickedRecommendations = recommendations.slice(0, 3);
  var allLong = pickedRecommendations.every(function (recommendation) {
    return recommendation.text.length > LONG_TEXT_TRESHOLD;
  });
  return /*#__PURE__*/_react["default"].createElement(StyledRecommendedCountries, {
    isMobile: isMobile,
    className: className
  }, /*#__PURE__*/_react["default"].createElement(Title, {
    isMobile: isMobile
  }, t('explore.recommendations.recommend'), /*#__PURE__*/_react["default"].createElement(StyledStar, {
    isMobile: isMobile
  })), pickedRecommendations.map(function (recommendation, index) {
    var text = recommendation.text,
        price = recommendation.price,
        link = recommendation.link; // только два длинных текста для десктопа, укорачиваем последний
    // только короткие тексты на мобиле

    var denyLong = isMobile || allLong && index === 2;
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: link
    }, /*#__PURE__*/_react["default"].createElement(StyledItemTitle, {
      maxLines: denyLong ? 1 : 2
    }, text), /*#__PURE__*/_react["default"].createElement(StyledItemPrice, {
      price: price,
      link: link
    }));
  }));
};

var StyledRecommendedCountries = _styledComponents["default"].div.withConfig({
  displayName: "RecommendedCountries__StyledRecommendedCountries",
  componentId: "sc-12vg4e9-0"
})(["box-sizing:border-box;font-size:14px;line-height:16px;width:220px;min-width:220px;height:180px;padding:8px;margin-right:8px;color:", ";background-color:", ";border-radius:", ";box-shadow:0px 1px 2px rgba(210,208,197,0.9),0px 10px 15px rgba(216,214,204,0.9);", ""], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.blackLight;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.yellowLight;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.shape.borderRadius;
}, function (_ref4) {
  var isMobile = _ref4.isMobile;
  return isMobile && "\n    font-size: 12px;\n    width: 200px;\n    height: 155px;\n    min-width: 200px;\n  ";
});

var Title = _styledComponents["default"].div.withConfig({
  displayName: "RecommendedCountries__Title",
  componentId: "sc-12vg4e9-1"
})(["display:flex;align-items:center;margin-bottom:8px;font-weight:bold;font-size:18px;color:", ";", ""], function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.blackBase;
}, function (_ref6) {
  var isMobile = _ref6.isMobile;
  return isMobile && "\n    font-size: 16px;\n  ";
});

var StyledStar = (0, _styledComponents["default"])(Star).withConfig({
  displayName: "RecommendedCountries__StyledStar",
  componentId: "sc-12vg4e9-2"
})(["margin-left:6px;width:18px;height:18px;", ""], function (_ref7) {
  var isMobile = _ref7.isMobile;
  return isMobile && "\n    width: 16px;\n    height: 16px;\n  ";
});

var StyledItemTitle = _styledComponents["default"].div.withConfig({
  displayName: "RecommendedCountries__StyledItemTitle",
  componentId: "sc-12vg4e9-3"
})(["display:-webkit-box;-webkit-line-clamp:", ";-webkit-box-orient:vertical;overflow:hidden;"], function (_ref8) {
  var maxLines = _ref8.maxLines;
  return maxLines;
});

var StyledItemPrice = (0, _styledComponents["default"])(_PriceLink["default"]).withConfig({
  displayName: "RecommendedCountries__StyledItemPrice",
  componentId: "sc-12vg4e9-4"
})(["margin:1px 0 4px 0;a{display:block;}"]);
var _default = RecommendedCountries;
exports["default"] = _default;